import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import * as idbKv from "idb-keyval";
import { DataManager } from "@/data-manager";
import AppSettings from "@/app-settings";
import countModule from "@/store/modules/count";
import popupDialogModule from "@/store/modules/popup-dialog";
import statusBarModule from "@/store/modules/status-bar";
import appSettingsModule from "@/store/modules/app-settings";
import { default as RootState, DownloadStatus } from "@/store/root-state";

Vue.use(Vuex);

let dataManager = new DataManager();



// class RootState {
//   dataManager: DataManager;
//   downloadStatus: DownloadStatus;
//   //appSettings: AppSettings;
//   //appSettingsApplied: Promise<void>;
//   sgln: string;
// }

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  // reducer: (state) => ({ navigation: state.navigation }), //only save navigation module
  // filter: (mutation) => mutation.type == 'addNavItem'
  modules: ["countModule", "appSettingsModule"]
})

export default new Vuex.Store<RootState>({
  state: {
    dataManager,
    downloadStatus: new DownloadStatus()
  },
  mutations: {
  },
  actions: {
    restoreSession(context) {
      context.dispatch("initializeDatabase");
      context.dispatch("countModule/restoreSession");
    },
    initializeDatabase(context) {
      dataManager.initializeDatabase();
    },
    addAnimals(context, animals: any[]) {
      dataManager.addAnimals(animals);
    },
    addItemsToDb(context, obj: any) {
      dataManager
        .addItems(obj.objectStoreName, obj.items)
        .then(() => {
          this.state.downloadStatus[obj.objectStoreName].state = "success";
        })
        .catch(error => {
          console.log("error adding items to DB: " + error)
          this.state.downloadStatus[obj.objectStoreName].state = "error";
        });
    }
  },
  modules: {
    countModule,
    popupDialogModule,
    statusBarModule,
    appSettingsModule
  },
  plugins: [ vuexLocal.plugin ]
});
